'use client';

import { useCallback } from 'react';
import { pushClickMail, pushClickPhone } from '@/lib/analytics';
import { formatPhone } from '@/features/pages/broker-list/utils';
import { IBrokerOfficeObjectResponse } from '@/types';

interface BrokerContactInfoShellProps {
  contacts?: IBrokerOfficeObjectResponse['contacts'];
  children: React.ReactNode;
}

export const BrokerContactInfoShell = ({ contacts, children }: BrokerContactInfoShellProps) => {
  const phone = contacts?.phone?.formatted ?? undefined;
  const email = contacts?.email ?? undefined;
  const phoneHref = formatPhone(phone).replace(/\s/g, '');

  const handlePhoneClick = useCallback(() => {
    if (phoneHref) pushClickPhone(phoneHref);
  }, [phoneHref]);

  const handleMailClick = useCallback(() => {
    if (email) pushClickMail(email);
  }, [email]);

  return (
    <div
      onClick={(e) => {
        const target = e.target as HTMLAnchorElement;
        if (target.tagName !== 'A') return;
        if (target.href.startsWith('tel:')) handlePhoneClick();
        if (target.href.startsWith('mailto:')) handleMailClick();
      }}
    >
      {children}
    </div>
  );
};
